import { useEffect, useState } from 'react';

export function useDebounce(value: any, delay: number) {
	const [debouncedValue, setDebouncevalue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncevalue(value);
		}, delay);
		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}
